<template>
  <div>
    <b-row
      class="content-header"
    >

      <!-- Content Left -->
      <b-col
        class="content-header-left mb-2"
        cols="12"
        md="6"
      >
        <b-row class="breadcrumbs-top">
          <b-col cols="12">
            <h1 class="custom-header-title">
              {{ suite.stringID }} - {{ suite.code }} - {{ suite.description }}
            </h1>
            <p class="log_info">
              Created by {{ getCreatedBy() }} on {{ getCreatedAt() }} <br>Last updated on {{ getUpdatedAt() }}
            </p>
          </b-col>
        </b-row>
      </b-col>

      <b-col
        class="content-header-right text-md-right d-md-block d-none mb-1"
        md="6"
        cols="12"
      >
        <div class="user_block pr_stage_type">
          <div class="user_avatar" />
          <div class="user_info">
            <h6>Sale Status</h6>
            <h5 :class="`text-${resolveSaleStatusVariant(suite.saleStatus)}`">
              {{ suite.saleStatus }}
            </h5>
          </div>
          <div class="action_button">
            <b-button
              v-b-modal.modal-update-sale-status
              variant="flat-primary"
            >
              <feather-icon
                icon="EditIcon"
                class="mr-50"
                size="16"
              />
            </b-button>
          </div>
        </div>
        <div class="user_block file_payment_type user__block-margin-adjust">
          <div class="user_avatar" />
          <div class="user_info">
            <h6>Reservable By</h6>
            <h5 :class="`text-${resolveReservableVariant(suite.reservableBy)}`">
              {{ suite.reservableBy }}
            </h5>
          </div>
          <div class="action_button">
            <b-button
              v-b-modal.modal-update-reservable
              variant="flat-primary"
            >
              <feather-icon
                icon="EditIcon"
                class="mr-50"
                size="16"
              />
            </b-button>
          </div>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="12">
        <b-card
          header-tag="header"
          class=""
        >
          <div class="d-flex justify-content-between">
            <b-table-simple
              borderless
              responsive
              class="custom-th-width"
            >
              <b-tbody>
                <b-tr>
                  <b-th width="230">
                    Suite Code
                  </b-th>
                  <b-td class="mt-50">
                    {{ suite.code || '-' }}
                  </b-td>
                </b-tr>
                <b-tr>
                  <b-th width="230">
                    Suite Name
                  </b-th>
                  <b-td class="mt-50">
                    {{ suite.description || '-' }}
                  </b-td>
                </b-tr>
                <b-tr>
                  <b-th width="230">
                    Suite Image
                  </b-th>
                  <b-td class="mt-50">
                    <b-img
                      v-if="suite.image"
                      :src="suite.image"
                      height="185"
                      width="200"
                    />
                  </b-td>
                </b-tr>
                <b-tr>
                  <b-th width="230">
                    Related GIS Page
                  </b-th>
                  <b-td class="mt-50">
                    {{ suite.gisPage ? `${suite.gisPage.pageID}: ${suite.gisPage.name}${suite.gisPage.description ? ` - ${suite.gisPage.description}` : ''}` : '-' }}
                  </b-td>
                </b-tr>
                <b-tr>
                  <b-th width="230">
                    Location
                  </b-th>
                  <b-td class="mt-50">
                    {{ suite.location ? suite.location.name :'-' }}
                  </b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple>
            <b-button
              variant="flat-primary"
              class="display-content"
              :to="{ name: 'products-suites-edit', params: { id: $route.params.id } }"
            >
              <feather-icon
                icon="EditIcon"
                class="mr-50"
                size="16"
              />
              <span class="align-middle">Edit</span>
            </b-button>
          </div>
        </b-card>
      </b-col>
    </b-row>

    <b-row v-if="suite.description">
      <b-col md="12">
        <lot-list :map-options="suite.gisPage ? suite.gisPage.maps : []" />
      </b-col>
    </b-row>

    <b-row
      v-if="suite.description"
      class="mt-2"
    >
      <b-col md="12">
        <suite-reservation
          :status-options="statusOptions"
          :product-options="productOptions"
          :lot-type-options="lotTypeOptions"
        />
      </b-col>
    </b-row>

    <b-modal
      id="modal-update-reservable"
      ref="update-reservable-modal"
      cancel-variant="flat-primary"
      modal-class="status-update-modal"
      ok-variant="success"
      ok-title="Update"
      cancel-title="Cancel"
      centered
      no-close-on-backdrop
      title="Update Reservable By"
      @ok="submitReservableForm"
    >
      <b-form @submit.prevent="submitReservableForm">
        <validation-observer
          ref="reservableEditForm"
        >
          <b-form-group
            label="Status*"
            label-for="h-activity-type-status"
          >
            <validation-provider
              #default="{ errors }"
              name="Status"
              vid="status"
              rules="required"
            >
              <v-select
                id="h-activity-type-status"
                v-model="reservableStatus"
                label="title"
                :options="reservableOptions"
                :reduce="title => title.code"
                :clearable="false"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </validation-observer>
      </b-form>
    </b-modal>

    <b-modal
      id="modal-update-sale-status"
      ref="update-sale-status-modal"
      cancel-variant="flat-primary"
      modal-class="status-update-modal"
      ok-variant="success"
      ok-title="Update"
      cancel-title="Cancel"
      centered
      no-close-on-backdrop
      title="Update Sales Status"
      @ok="submitSaleStatusForm"
    >
      <b-form @submit.prevent="submitSaleStatusForm">
        <validation-observer
          ref="saleStatusEditForm"
        >
          <b-form-group
            label="Status*"
            label-for="h-sale-status"
          >
            <validation-provider
              #default="{ errors }"
              name="Status"
              vid="status"
              rules="required"
            >
              <v-select
                id="h-sale-status"
                v-model="saleStatusValue"
                label="title"
                :options="saleStatusOptions"
                :reduce="title => title.code"
                :clearable="false"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </validation-observer>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BCard, BRow, BCol, BButton, BImg, BTableSimple, BTbody, BTr, BTd, BTh, BForm, BFormGroup,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import store from '@/store/index'
import { required } from '@validations'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import '@core/scss/vue/libs/vue-flatpicker.scss'
import LotList from '../lots/LotList.vue'
import SuiteReservation from '../../agency/reservation/suite-reservations/SuiteReservation.vue'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BButton,
    BTableSimple,
    BTbody,
    BTh,
    BTr,
    BTd,
    BImg,
    BForm,
    BFormGroup,
    vSelect,

    ValidationProvider,
    ValidationObserver,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
    LotList,
    SuiteReservation,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      suite: {},
      status: 'published',
      statusValidation: false,
      statusError: 'Valid status is required',
      reservableOptions: [
        { title: 'Staff-only', code: 'Staff-only' },
        { title: 'Not for reservation', code: 'Not for reservation' },
        { title: 'All agents & Staff', code: 'All agents & Staff' },
      ],
      saleStatusOptions: [
        { title: 'Open Sales', code: 'Open Sales' },
        { title: 'Not for sale', code: 'Not for sale' },
        { title: 'Only from reservations', code: 'Only from reservations' },
      ],
      statusOptions: [
        { title: 'Reserved', code: 'Reserved' },
        { title: 'Released', code: 'Released' },
        { title: 'Staff Hold', code: 'Staff Hold' },
      ],
      lotTypeOptions: [
        { title: 'Single', code: 'SINGLE' },
        { title: 'Double', code: 'DOUBLE' },
        { title: 'Twin Single', code: 'TWIN SINGLE' },
        { title: 'Twin Double', code: 'TWIN DOUBLE' },
        { title: 'Family', code: 'FAMILY' },
        { title: 'Super Family', code: 'SUPER FAMILY' },
      ],
      productOptions: [
        { title: 'Niche', code: '1' },
        { title: 'Pedestal', code: '5' },
        { title: 'Little Buddha', code: '6' },
      ],
      reservableStatus: 'Staff-only',
      saleStatusValue: 'Not for sale',
      syncLot: false,
      required,
    }
  },
  mounted() {
    this.$http.get(`reservation/suites/${this.$route.params.id}/show?syncLot=${this.syncLot}`)
      .then(response => {
        this.suite = response.data.data
        this.reservableStatus = this.suite.reservableBy || 'Staff-only'
        this.saleStatusValue = this.suite.saleStatus || 'Not for sale'

        store.commit('breadcrumb/REMOVE_BREADCRUMB')
        const newMeta = {
          active: true,
          text: `${this.suite.code} - ${this.suite.description}`,
        }
        store.commit('breadcrumb/UPDATE_BREADCRUMB', newMeta)
      })
      .catch(error => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: error.data.message ?? process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  },
  beforeRouteEnter(to, from, next) {
    let lotSync = false
    if (from.name === 'products-suites-index' || from.name === 'products-suites-edit') {
      lotSync = true
    }
    next(vm => {
      // eslint-disable-next-line no-param-reassign
      vm.syncLot = lotSync
    })
  },
  methods: {
    resolveReservableVariant(status) {
      if (status === 'Staff-only') return 'warning'
      if (status === 'Not for reservation') return 'secondary'
      if (status === 'All agents & Staff') return 'success'
      return 'primary'
    },
    resolveSaleStatusVariant(status) {
      if (status === 'Open Sales') return 'success'
      if (status === 'Not for sale') return 'secondary'
      if (status === 'Only from reservations') return 'warning'
      return 'primary'
    },
    getCreatedBy() {
      if (this.suite.createdByNvs) {
        return this.suite.createdByNvs.name
      }
      if (this.suite.createdBy) {
        return this.suite.createdBy
      }

      return ''
    },
    getCreatedAt() {
      if (this.suite.createdAtNvs) {
        return this.dateFormatWithTime(this.suite.createdAtNvs)
      }
      if (this.suite.createdAt) {
        return this.dateFormatWithFormatNTZ(this.suite.createdAt, 'DD/MM/YYYY, hh:mma ')
      }

      return ''
    },
    getUpdatedAt() {
      if (this.suite.updatedAtNvs) {
        return this.dateFormatWithTime(this.suite.updatedAtNvs)
      }
      if (this.suite.updatedAt) {
        return this.dateFormatWithFormatNTZ(this.suite.updatedAt, 'DD/MM/YYYY, hh:mma ')
      }

      return ''
    },
    submitReservableForm() {
      this.$refs.reservableEditForm.validate().then(success => {
        if (success) {
          const formData = new FormData()
          formData.append('status', this.reservableStatus)

          this.$http.patch(`reservation/suites/${this.$route.params.id}/reservable/update`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
          })
            .then(() => {
              this.suite.reservableBy = this.reservableStatus

              this.$swal({
                title: 'Status Updated!',
                html: 'The status for this suite reservable by has been updated',
                // eslint-disable-next-line global-require
                imageUrl: require('@/assets/images/icons/save.png'),
                imageWidth: 80,
                imageHeight: 80,
                imageAlt: 'Custom Icon',
                showCancelButton: false,
                confirmButtonText: 'Okay',
                customClass: {
                  confirmButton: 'btn btn-primary',
                },
                buttonsStyling: false,
              })
            })
            .catch(error => {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: error.data.message || process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
                  icon: 'AlertTriangleIcon',
                  variant: 'danger',
                },
              })
            })
        }
      })
    },

    submitSaleStatusForm() {
      this.$refs.saleStatusEditForm.validate().then(success => {
        if (success) {
          const formData = new FormData()
          formData.append('status', this.saleStatusValue)

          this.$http.patch(`reservation/suites/${this.$route.params.id}/sale-status/update`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
          })
            .then(() => {
              this.suite.saleStatus = this.saleStatusValue

              this.$swal({
                title: 'Status Updated!',
                html: 'The sale status for this suite has been updated',
                // eslint-disable-next-line global-require
                imageUrl: require('@/assets/images/icons/save.png'),
                imageWidth: 80,
                imageHeight: 80,
                imageAlt: 'Custom Icon',
                showCancelButton: false,
                confirmButtonText: 'Okay',
                customClass: {
                  confirmButton: 'btn btn-primary',
                },
                buttonsStyling: false,
              })
            })
            .catch(error => {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: error.data.message || process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
                  icon: 'AlertTriangleIcon',
                  variant: 'danger',
                },
              })
            })
        }
      })
    },
  },
}
</script>

<style lang="scss">
  .item-field-custom-class {
    color: #000000;
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
  }
  .display-content {
    display: contents;
  }

  .custom-th-width {
    .table th {
        padding: 0.72rem 2rem 0.72rem 0.72rem;
    }
  }
</style>
